module.exports = __webpack_public_path__ + "img/tab8.cb27916e.png";